<div class="modal-header modal-pepsico-header">
    <h1 class="modal-title fs-5" id="exampleModalLabel">PUNTOS RESTANTES</h1>
</div>
<div class="modal-body text-center">
    <div class="order-tracking-unique">
        <h6 class="mb-4">Aún tienes puntos restantes te recomendamos algunas opciones.</h6>
        <!--PRIRAMIDE-->
        <section class="container-piramid">
            <div class="piramid">

                <!-- Nivel 3 -->
                <div class="piramid-level piramid-level-3" (click)="goToCatalog(3,100000)">
                    <span class="piramid-number">3+</span>
                    <div class="piramid-content">
                        <img class="piramid-img"
                            src="assets/images/categoria-carrusel-artpersonales.png"
                            alt="Premio nivel 3">
                        <p class="piramid-text">Premios de 3 o más puntos.</p>
                    </div>
                </div>

                <!-- Nivel 2 -->
                <div class="piramid-level piramid-level-2" (click)="goToCatalog(2,2)">
                    <span class="piramid-number">2</span>
                    <div class="piramid-content">
                        <img class="piramid-img"
                            src="assets/images/categoria-carrusel-artpersonales.png"
                            alt="Premio nivel 2">
                        <p class="piramid-text">Premios de 2 puntos.</p>
                    </div>
                </div>

                <!-- Nivel 1 -->
                <div class="piramid-level piramid-level-1" (click)="goToCatalog(1,1)">
                    <span class="piramid-number">1</span>
                    <div class="piramid-content">
                        <img class="piramid-img"
                            src="assets/images/categoria-carrusel-artpersonales.png"
                            alt="Premio nivel 1">
                        <p class="piramid-text">Premios de 1 punto.</p>
                    </div>
                </div>

            </div>
        </section>
        <div class="d-flex jf-center">
            <button type="button" class="btn btn-primary perfilbtn-pep" (click)="close()">Cerrar</button>
        </div>
    </div>
</div>